import React, { useEffect, useState } from "react";
import { CrossFillMini, SearchOutine } from "../../assets/SvgIcons";
import { useNavigate } from "react-router-dom";
import axiosInstance from "../../redux/helpers/axios";
import axios from "axios";
import toast from "react-hot-toast";
// import { watchdata } from "../../assets/watch";

const CreateListing = () => {
  const [result, setResult] = useState([]);
  const [param, setParam] = useState("");

  async function searchWatches(searchQuery) {
    // Convert the search query to lowercase for case-insensitive comparison
    const query = searchQuery.toLowerCase();

    // Filter the data based on the search query
    const watchdata = await axiosInstance.get("/watch/get-all");

    const res = watchdata?.data?.watches.filter((item) => {
      const { refId, title, manufacturer } = item;

      return (
        refId?.toLowerCase().includes(query) ||
        title?.toLowerCase().includes(query) ||
        manufacturer?.toLowerCase().includes(query)
      );
    });
    setResult(res);
  }

  const [isModalOpen, setIsModalOpen] = useState(false);

  const openModal = () => setIsModalOpen(true);
  const closeModal = () => setIsModalOpen(false);

  useEffect(() => {
    if (param !== null && param !== "") {
      searchWatches(param);
    } else {
      setResult([]);
    }
  }, [param]);

  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    model: "",
    refId: "",
    title: "",
    caseMaterial: "",
    dialColor: "",
    manufacturer: "",
    caseDiameter: "",
    movement: "",
  });

  const [imageFile, setImageFile] = useState(null);
  const [message, setMessage] = useState("");

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleFileChange = (e) => {
    setImageFile(e.target.files[0]);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const id = toast.loading("Loading...");

    try {
      const response = await axiosInstance.get(`/utils/aws/get-presigned-url`, {
        params: {
          filename: imageFile.name,
          fileType: imageFile.type,
        },
      });

      const { url, objectUrl } = response.data;
      await axios.put(url, imageFile, {
        headers: {
          "Content-Type": imageFile.type,
        },
      });
      const result = await axiosInstance.post("/admin/create-watch", {
        ...formData,
        imageUrl: objectUrl,
      });

      toast.success("Watch added successfully!", { id: id });
      setFormData({
        model: "",
        refId: "",
        title: "",
        caseMaterial: "",
        dialColor: "",
        manufacturer: "",
        caseDiameter: "",
        movement: "",
      });
      setImageFile(null);
      closeModal();
      navigate("/listing/preview", { state: result.data.watch });
    } catch (err) {
      setMessage("Failed to add watch.");
      toast.dismiss(id);
    }
  };

  return (
    <div className=" w-full lg:p-4 md:p-4 sm:p-0">
      <h1 className="lg:text-4xl md:text-2xl sm:text-xl mb-8">
        Create Listing
      </h1>
      <div className="mx-auto lg:w-8/12 mt-8">
        {" "}
        <p className="text-[12px] mb-2 ml-1 text-gray-500">
          {" "}
          What watch would you like to sell?
        </p>
        <SearchBar param={param} setParam={setParam} />
        <SearchIndexSuggestion />
        <div className="bg-primarylight rounded-lg mt-4">
          {result?.length > 0 ? (
            <>
              {" "}
              {result?.map((res, index) => {
                return (
                  <SearchSuggestionCard
                    result={res}
                    key={index}
                    index={index}
                  />
                );
              })}
            </>
          ) : (
            <>
              <div className="flex flex-col items-center gap-4 py-3">
                <p>Can't find your desired watch?</p>
                <div
                  onClick={openModal}
                  className="bg-black text-white rounded-lg px-4 py-2 cursor-pointer"
                >
                  Add New Watch
                </div>
              </div>
            </>
          )}
        </div>
      </div>
      {isModalOpen && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
          <div className="bg-white p-8 rounded-2xl w-full max-w-[720px]">
            <div className="flex justify-between items-start">
              <h1 className="lg:text-3xl md:text-2xl sm:text-xl">
                Add New Watch
              </h1>
              <button className="" onClick={closeModal}>
                {CrossFillMini}
              </button>
            </div>

            <div className="max-w-xl mx-auto ">
              <form onSubmit={handleSubmit} className="grid gap-4">
                <div>
                  <label className="block mb-1">Model</label>
                  <input
                    name="model"
                    value={formData.model}
                    onChange={handleChange}
                    required
                    className="w-full border p-2 rounded"
                  />
                </div>

                <div>
                  <label className="block mb-1">Reference ID</label>
                  <input
                    name="refId"
                    value={formData.refId}
                    onChange={handleChange}
                    required
                    className="w-full border p-2 rounded"
                  />
                </div>

                <div>
                  <label className="block mb-1">Title</label>
                  <input
                    name="title"
                    value={formData.title}
                    onChange={handleChange}
                    required
                    className="w-full border p-2 rounded"
                  />
                </div>

                <div>
                  <label className="block mb-1">Case Material</label>
                  <input
                    name="caseMaterial"
                    value={formData.caseMaterial}
                    onChange={handleChange}
                    required
                    className="w-full border p-2 rounded"
                  />
                </div>

                <div>
                  <label className="block mb-1">Dial Color</label>
                  <input
                    name="dialColor"
                    value={formData.dialColor}
                    onChange={handleChange}
                    required
                    className="w-full border p-2 rounded"
                  />
                </div>

                <div>
                  <label className="block mb-1">Manufacturer</label>
                  <input
                    name="manufacturer"
                    value={formData.manufacturer}
                    onChange={handleChange}
                    required
                    className="w-full border p-2 rounded"
                  />
                </div>

                <div>
                  <label className="block mb-1">Case Diameter (mm)</label>
                  <input
                    type="number"
                    name="caseDiameter"
                    value={formData.caseDiameter}
                    onChange={handleChange}
                    required
                    className="w-full border p-2 rounded"
                  />
                </div>

                <div>
                  <label className="block mb-1">Movement</label>
                  <input
                    name="movement"
                    value={formData.movement}
                    onChange={handleChange}
                    required
                    className="w-full border p-2 rounded"
                  />
                </div>

                <div>
                  <label className="block mb-1">Watch Image</label>
                  <input
                    type="file"
                    accept="image/*"
                    onChange={handleFileChange}
                    className="w-full"
                  />
                </div>

                <button
                  type="submit"
                  className="bg-blue-600 text-white px-4 py-2 rounded hover:bg-blue-700"
                >
                  Add Watch
                </button>
              </form>

              {message && <p className="mt-4 text-green-600">{message}</p>}
            </div>

            <div className="flex gap-3 items-start mt-6">
              {/* {imagesArray?.map((img, index) => {
                return (
                  <div className="flex flex-col justify-center items-center p-2">
                    <img src={img?.url} alt="" height={150} width={150} />
                    <p className="text-[14px] mt-2 text-center">{img?.label}</p>
                  </div>
                );
              })} */}
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default CreateListing;

const SearchBar = ({ param, setParam }) => {
  return (
    <div className="p-2.5 rounded bg-[#F3F3F3] flex items-center w-full">
      <input
        type="text"
        placeholder="Reference number, brand, model"
        className="pr-1 bg-[#F3F3F3] w-full outline-none"
        value={param}
        onChange={(e) => setParam(e.target.value)}
      />
      {SearchOutine}
    </div>
  );
};

const SearchIndexSuggestion = () => {
  return (
    <div className="mt-4 rounded-lg bg-primary p-4 flex items-center gap-4">
      <img
        src="https://main.d2qfb7a0oc8xva.amplifyapp.com/static/media/9.13f6f2f51394552b0d2c0a8415beee8b.svg"
        alt=""
        height={120}
        width={120}
        className="border rounded-lg h-[120px] w-[120px]"
      />
      <div className="text-[12px]">
        <p>
          To determine the exact model of your watch, enter the watch's
          reference number.
        </p>
        <p className="text-secondarylight mt-2">
          You can usually find the reference number on the case back, between
          the lugs, or sometimes even on the dial. The number should also be in
          the paperwork accompanying the watch or on the original invoice.
        </p>{" "}
      </div>
    </div>
  );
};

const SearchSuggestionCard = ({ result, index }) => {
  const navigate = useNavigate();
  return (
    <div
      onClick={() => navigate("/listing/preview", { state: result })}
      className={`p-4 flex items-center gap-4 hover:bg-primary cursor-pointer ${
        index !== 0 ? "border-t border-t-primary rounded-b-lg" : "rounded-t-lg"
      }`}
    >
      <img
        src={result?.imageUrl}
        alt=""
        height={120}
        width={120}
        className="border rounded-lg h-[120px] w-[120px]"
      />
      <div className="text-[12px] pr-4  w-full">
        <h2 className="text-xl">{result?.title}</h2>
        <h2 className="text-xl mt-0.5 mb-1">{result?.refId}</h2>
        <div className="flex gap-4 justify-between items-start">
          <div>
            <p className="font-semibold">Case Material</p>
            <div className="flexjustify-center items-center">
              <p>{result.caseMaterial}</p>
            </div>
          </div>
          <div>
            <p className="font-semibold">Dial</p>
            <div className="flex justify-center items-center">
              <p>{result.dialColor}</p>
            </div>
          </div>
          <div>
            <p className="font-semibold">Case Diameter</p>
            <p>{result.caseDiameter} mm</p>
          </div>
        </div>
      </div>
    </div>
  );
};
